import { gql } from '@apollo/client'

export const resolvers = {
  Mutation: {
    activateBookingClass(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'BookingClass',
          id
        }),
        fragment: gql`
          fragment BookingClassActivatedAt on BookingClass {
            activatedAt
          }
        `,
        data: {
          activatedAt: new Date(),
          __typename: 'BookingClass'
        }
      })

      return null
    },
    deactivateBookingClass(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'BookingClass',
          id
        }),
        fragment: gql`
          fragment BookingClassActivatedAt on BookingClass {
            activatedAt
          }
        `,
        data: {
          activatedAt: null,
          __typename: 'BookingClass'
        }
      })

      return null
    }
  }
}
